import React from 'react'
import './index.css'
import View from 'components/View'

/**
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductAOVLockIcon () {
  return (
    <View className='product-aov-lock-icon'>
      <svg
        width='32'
        height='32'
        viewBox='0 0 32 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect
          width='31.9999'
          height='31.9999'
          rx='5.99998'
          fill='#DAD8E4'
        />
        <path
          d='M15.5 13L9.5 21.5L11 24.5H15.5L22.5 14.5L20 13.5L15.5 13Z'
          fill='#838092'
        />
        <path
          d='M16 19.3333V21M12.25 24.3333H19.7504C21.1311 24.3333 22.2504 23.214 22.2504 21.8333V15.7222C22.2504 14.3415 21.1311 13.2222 19.7504 13.2222H12.25C10.8693 13.2222 9.75 14.3415 9.75 15.7222V21.8333C9.75 23.214 10.8693 24.3333 12.25 24.3333ZM19.1253 13.2222V10.7918C19.1253 9.06582 17.7262 7.66666 16.0002 7.66666C14.2743 7.66666 12.8751 9.06582 12.8751 10.7918V13.2222H19.1253ZM17.25 17.6667C17.25 18.357 16.6904 18.9167 16 18.9167C15.3096 18.9167 14.75 18.357 14.75 17.6667C14.75 16.9763 15.3096 16.4167 16 16.4167C16.6904 16.4167 17.25 16.9763 17.25 17.6667Z'
          stroke='#191531'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </View>
  )
}
